import React, { useCallback } from 'react';

import { Box, Divider, Stack, Typography } from '@mui/material';
import List from '@mui/material/List';

import DealCrawlerInclusionListItem from './DealCrawlerInclusionListItem';

export type InclusionForm = {
  id: string;
  description: string;
  isActive: boolean;
};

type Props = {
  title: string;
  subtitle?: string;
  inclusionList: Array<InclusionForm>;
  isEditEnabled?: boolean;
  setInclusionList: (inclusions: Array<InclusionForm>) => void;
};

function DealCrawlerInclusionList({ title, subtitle, inclusionList, setInclusionList, isEditEnabled }: Props) {
  const handleEditInclusion = useCallback(
    (oldName: string, newInclusion: InclusionForm) => {
      const newInclusions = inclusionList.map((i) => (i.description === oldName ? newInclusion : i));
      setInclusionList(newInclusions);
    },
    [inclusionList, setInclusionList],
  );

  return (
    <Stack marginTop={3} spacing={1}>
      <Typography variant="h5">{title}</Typography>
      {subtitle && <Typography>{subtitle}</Typography>}

      <Box borderTop={1} borderColor="divider">
        <List sx={{ maxHeight: '300px', overflow: 'auto' }}>
          {inclusionList.map((inclusion) => (
            <Box key={inclusion.description}>
              <DealCrawlerInclusionListItem
                inclusion={inclusion}
                onEditInclusion={handleEditInclusion}
                isEditEnabled={isEditEnabled}
              />
              <Divider component="li" />
            </Box>
          ))}
        </List>
      </Box>
    </Stack>
  );
}

export default DealCrawlerInclusionList;
